<template>
  <div>
    <div class="sayfahead">
      <h1>{{Sayfa.Adi}}</h1>
      <el-button-group v-if="tableDisplay" class="float-right">

        <el-button type="success" size="small" class="YeniBtn" @click="Excel"
                   icon="el-icon-download">Excel İndir
        </el-button>
        <a @click="Yazdir" class="el-button YeniBtn el-button--primary el-button--small"
        ><i class="feather-printer"></i> Yazdır
        </a>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">

          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">

            <el-col :span="4">
              <el-form-item label="Site / Bina" prop="Bina_id">
                <el-select v-model="Form.Bina_id" filterable clearable>
                  <el-option-group
                    label="Site Listesi">
                    <el-option
                      v-for="item in Siteler"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                  <el-option-group
                    label="Bina Listesi">
                    <el-option
                      v-for="item in Binalar"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Rapor Tarih Aralığı" prop="Tarih">
                <el-date-picker
                  :clearable="false"
                  v-model="Form.Tarih"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Başlangıç Tarihi"
                  end-placeholder="Bitiş Tarihi"
                  format="dd.MM.yyyy"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="İstek Türü" prop="Tur">
                <el-select v-model="Form.Tur" filterable>
                  <el-option
                    key="1"
                    label="İşlem Tarihi"
                    value="1">
                  </el-option>
                  <el-option
                    key="2"
                    label="Ödeme Tarihi"
                    value="2">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="Kategori" prop="Kategori_id">
                <el-cascader
                  collapse-tags
                  :props="{ multiple: true}"
                  :options="Kategoriler"
                  v-model="Form.Kategori_id"
                  filterable clearable></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="Kasa" prop="Kasa_id">
                <el-cascader
                  collapse-tags
                  :props="{ multiple: false}"
                  :options="Kasalar"
                  v-model="Form.Kasa_id"
                  filterable clearable></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="Kullanıcı" prop="Kullanici_id">
                <el-select v-model="Form.Kullanici_id" filterable clearable>
                  <el-option
                    v-for="item in Kullanicilar"
                    :key="item.id"
                    :label="item.AdSoyad"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item class="Tooltip" label="Virman" prop="Virman">
                <el-tooltip class="item" effect="dark" content="Raporlamaya virmanlarıda getirir."
                            placement="top">
                  <i class="el-icon-info text-primary cursor-pointer"></i>
                </el-tooltip>
                <el-switch v-model="Form.Virman"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>

          <div class="yazdirtable">
            <h1>{{Sayfa.Adi}}</h1>
            <table class="table table-bordered">
              <thead>
              <tr>
                <th>İşlem Tarihi</th>
                <th>Ödeme Tarihi</th>
                <th>Cari</th>
                <th>Site/Bina</th>
                <th>Kasa</th>
                <th>Kategori</th>
                <th>Makbuz No</th>
                <th>Açıklama</th>
                <th>Kullanıcı</th>
                <th class="text-right">Tutar</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="t in tableData">
                <td>{{t.Tarih}}</td>
                <td>{{t.oTarihi}}</td>
                <td>{{t.Cari}}</td>
                <td>{{t.Bina}}</td>
                <td>{{t.Kasa}}</td>
                <td>{{t.Kategori}}</td>
                <td>{{t.MakbuzNo}}</td>
                <td>{{t.Aciklama}}</td>
                <td>{{t.Kullanici}}</td>
                <td class="text-right">{{t.Tutar}}</td>
              </tr>
              </tbody>
              <tbody>
              <tr>
                <td colspan="9"></td>
                <td class="text-right">{{AltToplam}}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <el-table
            v-if="tableDisplay"
            class="table-xs yazdirma"
            :data="tableData"
            style="width: 100%"
            width="100%"
            show-summary
            :height="Height"
            :summary-method="TableFooter"
            :row-class-name="TableClass"
          >
            <el-table-column
              label="İşlem Tarihi"
              prop="Tarih"
              width="150">
            </el-table-column>
            <el-table-column
              label="Ödeme Tarihi"
              prop="oTarihi"
              width="100">
            </el-table-column>
            <el-table-column
              label="Cari"
              prop="Cari"
              width="250">
            </el-table-column>
            <el-table-column
              label="Site/Bina"
              prop="Bina"
              width="200">
            </el-table-column>
            <el-table-column
              label="Kasa"
              prop="Kasa"
              width="100">
            </el-table-column>
            <el-table-column
              label="Kategori"
              prop="Kategori"
              width="150">
            </el-table-column>
            <el-table-column
              label="Makbuz No"
              prop="MakbuzNo"
              width="100">
              <template slot-scope="scope">
                <a v-if="scope.row.MakbuzNo" @click="MakbuzGetir(scope.row.MakbuzNo)">
                  <span>{{ scope.row.MakbuzNo }}</span>
                </a>
              </template>
            </el-table-column>
            <el-table-column
              label="Açıklama"
              prop="Aciklama">
            </el-table-column>
            <el-table-column
              label="Kullanıcı"
              prop="Kullanici"
              width="100">
            </el-table-column>
            <el-table-column
              label="Tutar"
              prop="Tutar"
              width="100"
              align="right">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <MakbuzDetay v-if="MakbuzDetayModal" :mNo="mNo" @MakbuzDetayModal="MakbuzDetayModal=false"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>
  </div>
</template>

<script>
  import XLSX from 'xlsx';
  import Yukleniyor from "../../../components/Doc/Yukleniyor";
  import MakbuzDetay from "../../../components/Pack/Vezne/MakbuzDetay";

  const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
    name: XLSX.utils.encode_col(i),
    key: i
  }));


  export default {
    components: {MakbuzDetay, Yukleniyor},
    data() {
      return {
        Height: 0,
        SecilenKasa: '',
        lo: false,
        Yetki: false,
        Kaydet: false,
        Sayfa: {
          Adi: 'Kasa Gider Raporu',
          ButtonAdi: 'Uygula',
          FiltreAdi: 'Filtreleme',
        },
        Form: {
          Virman: false,
          Bina_id: null,
          Kasa_id: null,
          Kullanici_id: null,
          Tur: '1',
          Tarih: []
        },
        FormHata: {
          Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
        MakbuzDetayModal: false,
        mNo: null,
        Kasalar: [],
        Binalar: [],
        Siteler: [],
        Kullanicilar: [],
        Kategoriler: [],
        tableData: [],
        ExcelData: [],
        tableDisplay: false,
        AltToplam: 0
      }
    },
    methods: {
      MakbuzGetir(mNo) {
        this.mNo = mNo;
        this.MakbuzDetayModal = true
      },
      Excel(evt) {

        const ws = XLSX.utils.json_to_sheet(this.ExcelData);
        const wb = XLSX.utils.book_new();
        ws['!cols'] = [
          {wch: 15},
          {wch: 15},
          {wch: 30},
          {wch: 30},
          {wch: 25},
          {wch: 20},
          {wch: 15},
          {wch: 40},
          {wch: 20},
          {wch: 12},
        ];

        XLSX.utils.cell_set_number_format(ws['F2'], '0.00');

        wb.Props = {
          Title: this.Sayfa.Adi + " (" + this.SecilenKasa + ")",
          Author: "Aidatim APP",
          Manager: "Aidatim APP",
          Company: "Aidatim",
          Category: "Finans",
          Keywords: "Aidatim",
          Comments: this.Sayfa.Adi + " (" + this.SecilenKasa + ")",
        };
        XLSX.utils.book_append_sheet(wb, ws, this.SecilenKasa);
        XLSX.writeFile(wb, this.Sayfa.Adi + " (" + this.SecilenKasa + ")" + ".xlsx");
      },
      Yazdir() {
        this.$prompt('Yazdırılacak sayfanın adını değişebilirsiniz.', 'Sayfa Adı', {
          confirmButtonText: 'Yazıcıya Gönder',
          cancelButtonText: 'Vazgeç',
          inputValue: this.Sayfa.Adi,
          inputPlaceholder: 'Yazdırma Sayfası'
        }).then(({value}) => {
          this.Sayfa.Adi = value;
          this.YaziciyaGonder(value);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Yazdırma İptal Edildi'
          });
        });
      },
      YaziciyaGonder() {
        setTimeout(() => {
          window.print();
        }, 100);
      },
      TableClass({row}) {
        return row.TableClass
      },
      TableFooter() {
        const sums = [];
        sums[9] = this.AltToplam;
        return sums;
      },
      Getir() {

        this.$refs['RaporForm'].validate((valid) => {
          if (valid) {
            if (this.Kasalar.filter(c => c.id.includes(this.Form.Kasa_id)).length>0) this.SecilenKasa = this.Form.Kasa_id ? this.Kasalar.filter(c => c.id.includes(this.Form.Kasa_id))[0]['Adi'] : '';
            this.lo = true;
            this.$store.dispatch("Post", {...this.Form, path: 'raporlama/kasa/gider'})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.tableData = response.tableData;
                  this.AltToplam = response.AltToplam;
                  this.ExcelData = response.ExcelData;
                  if (this.tableData) this.tableDisplay = true;
                  this.Height = window.innerHeight - 220
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        })

      },
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'muhasebe/kasa'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Kasalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Kategoriler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'muhasebe/list/bina'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Binalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'muhasebe/list/site'})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Siteler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'spesiyal/kullanici'})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Kullanicilar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

      },
    },
    created() {
      this.SayfaYukle();
      this.Yetki = this.$store.getters.Yetki.raporlama == 2 ? true : false;
      var Gun = new Date();
      this.Form.Tarih[0] = Gun;
      this.Form.Tarih[1] = Gun;
      //this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
      //this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
      if (this.$store.getters.BinaBilgi) {
        this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
      }
    },

  }
</script>



// WEBPACK FOOTER //
// src/pages/Raporlama/kasa/gider.vue